export const deepCopy = (originalValue) => {
  if (!originalValue) {
    return originalValue
  }
  return JSON.parse(JSON.stringify(originalValue))
}
